import styled from 'styled-components';

const Input = styled('input')`
  width: ${({ width }) => (width ? width : '100%')};
  border: 1px solid var(--color-auth-input-bg);
  border-radius: 4px;
  padding: 12px;
  outline: none;
  background: var(--color-auth-input-bg);
  color: var(--color-auth-label);
  -webkit-user-select: text;

  ${(props: any) => {
    if (props['data-haserror']) {
      return `
        background: ${props.theme.colors.alert_400};
        border-color: ${props.theme.colors.alert_400};
        color: white;
      `;
    }
  }}

  ${({ theme }) => theme.fontTypes.type3}
`;

export default Input;
